import { useCallback, useState } from 'react';
import { IReportType } from '../../../../types/reports';

const availableReports: IReportType[] = [
  {
    id: 'metocean-conditions',
    name: 'Metocean Conditions',
    additionalText: '(beta version)',
    category: 'on-demand',
    disabled: false,
  },
  {
    id: 'preprocessed-data',
    name: 'Pre-Processed (.xlsx)',
    category: 'pre-processed',
    disabled: false,
  },
];

export const useReportsNavigation = () => {
  const [activeReport, setActiveReport] = useState<string | null>(
    'metocean-conditions'
  );

  const handleReportTypeChanged = useCallback((report: IReportType) => {
    if (!report.disabled) {
      setActiveReport(report.id);
    }
  }, []);

  const currentReport =
    availableReports.find((report) => report.id === activeReport) || null;

  const isReportActive = useCallback(
    (reportId: string) => {
      return activeReport === reportId;
    },
    [activeReport]
  );

  return {
    activeReport,
    setActiveReport,
    availableReports,
    handleReportTypeChanged,
    currentReport,
    isReportActive,
  };
};
